import SliderControls from './SliderControls';
export default SliderControls;